import { FlowStats } from "@/types/stats";
import { get } from "./client";

export async function getFlowStats(
  flowId: string,
  days: number = 30,
  stepId?: string | null,
): Promise<FlowStats> {
  const query = new URLSearchParams({ days: String(days) });
  if (stepId) query.set("step_id", stepId);
  return get<FlowStats>(`/stats/flow/${flowId}?${query.toString()}`);
}
